import React, { useEffect, useRef } from 'react';

import * as d3 from 'd3';

const fullHeight = 18;
const bgHeight = 14;

export const ScatterChartDataPointType = {
  On: 1,
  // Off: 0,
  DC: -1
}

// values: [[1720788781, 1], [1720875094, 0], [1720875181, null]]
export function convertValuesToScatterChartDataPointList(values, valueReplacer = undefined) {
  if (valueReplacer === undefined) {
    valueReplacer = (x) => x;
  }
  if (values.length < 2) {
    return [[], 0, 0];
  }

  const boolValues = [];
  for (let i = 0; i < values.length; i++) {
    let currentValue = values[i];
    currentValue = [currentValue[0], valueReplacer(currentValue[1])]
    if ((currentValue[1] === false) || (currentValue[1] === 0)) {
      boolValues.push([currentValue[0], false]);
    } else if ((currentValue[1] === true) || (currentValue[1] > 0)) {
      boolValues.push([currentValue[0], true]);
    } else {
      boolValues.push([currentValue[0], null]);
    }
  }

  const _boxes = [];
  const dataLength = values[values.length - 1][0] - values[0][0];
  for (let i = 1; i < boolValues.length; i++) {
    const previousValue = boolValues[i - 1];
    const currentValue = boolValues[i];
    if (previousValue[1] === false) {
      continue;
    } else if (previousValue[1] === null) {
      _boxes.push(createScatterChartDataPoint(previousValue[0] - boolValues[0][0], currentValue[0] - previousValue[0], ScatterChartDataPointType.DC));
    } else if (previousValue[1] === true) {
      _boxes.push(createScatterChartDataPoint(previousValue[0] - boolValues[0][0], currentValue[0] - previousValue[0], ScatterChartDataPointType.On));
    }
  }

  const mergedBoxes = [];
  if (_boxes.length > 0)
    mergedBoxes.push(_boxes[0]);
  for (let i = 1; i < _boxes.length; i++) {
    let currentBox = _boxes[i];
    let lastBox = mergedBoxes[mergedBoxes.length - 1]
    if ((lastBox.type === currentBox.type) && (lastBox.start + lastBox.length === currentBox.start)) {
      lastBox.length += currentBox.length; // will change _boxes
    } else {
      mergedBoxes.push(currentBox);
    }
  }

  let numberOfChanges = 0;
  for (let i = 0; i < mergedBoxes.length; i++) {
    const currentBox = mergedBoxes[i];
    if (currentBox.type === ScatterChartDataPointType.On) {
      numberOfChanges += 1;
    }
  }

  return [mergedBoxes, numberOfChanges, dataLength];
}

export function createScatterChartDataPoint(start, length, type) {
  return { start, length, type };
}

// data is an array of ScatterChartDataPoint
export function ScatterChart({
  chartKey, className, fullWidth, onColor, data, dataLength, minRectWidth
}) {
  const chartRef = useRef();

  useEffect(() => {
    chartRef.current.innerHTML = "";

    const svg = d3.select(chartRef.current)
      .append("svg").attr("viewBox", [0, 0, fullWidth, fullHeight])
      .attr("width", fullWidth)
      .attr("height", fullHeight);

    // dc pattern
    const pattern = svg.append("pattern")
      .attr("id", chartKey + "-chart-bg-pattern")
      .attr("width", 4.95)
      .attr("height", 10)
      .attr("patternUnits", "userSpaceOnUse")
      .attr("patternTransform", "rotate(45)");
    pattern.append("rect")
      .attr("fill", "#151515")
      .attr("width", 20)
      .attr("height", 10)
      .attr("x", 0)
      .attr("y", 0);
    pattern.append("line")
      .attr("stroke", "#7D7D7D")
      .attr("stroke-width", 0.8)
      .attr("y2", 10);

    // bg
    svg.append("rect")
      .attr("transform", `translate(0, ${(fullHeight - bgHeight) / 2})`)
      .attr("width", fullWidth)
      .attr("height", bgHeight)
      // .attr("rx", 8)
      .attr("opacity", "0.2")
      .attr("fill", "white");

    const baseSize = fullWidth / dataLength;
    // console.log("mohsen", chartKey, data, fullWidth, baseSize, dataLength);
    // console.log("mohsen2", data[0].start * baseSize, fullWidth-minRectWidth);
    for (let i = 0; i < data.length; i++) {
      const dataPoint = data[i];
      if (dataPoint.type === ScatterChartDataPointType.On) {
        svg.append("rect")
          .attr("transform", `translate(${Math.min(dataPoint.start * baseSize, fullWidth - minRectWidth)}, 0)`)
          .attr("width", Math.max(dataPoint.length * baseSize, minRectWidth))
          .attr("height", fullHeight)
          .attr("rx", 2)
          .attr("fill", onColor);
      } else if (dataPoint.type === ScatterChartDataPointType.DC) {
        svg.append("rect")
          .attr("transform", `translate(${Math.min(dataPoint.start * baseSize, fullWidth - minRectWidth)}, 0)`)
          .attr("width", Math.max(dataPoint.length * baseSize, minRectWidth))
          .attr("height", fullHeight)
          .attr("rx", 2)
          .attr("fill", "url(#" + chartKey + "-chart-bg-pattern)");
      }
    }
  }, [chartKey, fullWidth, onColor, data, dataLength, minRectWidth]);


  return (
    <div className={className} ref={chartRef} />
  );
}

/*
  <ScatterChart chartKey="playground-svg" className="playground-svg"
    fullWidth={300} minRectWidth={0} onColor="#FFD94D" 
    data={[
        createScatterChartDataPoint(8, 2, ScatterChartDataPointType.On),
        createScatterChartDataPoint(12, 8, ScatterChartDataPointType.DC),
        createScatterChartDataPoint(25, 8, ScatterChartDataPointType.On),
        createScatterChartDataPoint(45, 1, ScatterChartDataPointType.On),
        createScatterChartDataPoint(50, 15, ScatterChartDataPointType.DC),
        createScatterChartDataPoint(70, 1, ScatterChartDataPointType.On),
        createScatterChartDataPoint(75, 1, ScatterChartDataPointType.On),
    ]} 
    dataLength={80} />
  <ScatterChart chartKey="playground-svg" className="playground-svg"
    fullWidth={300} minRectWidth={0} onColor="#39E4EF" 
    data={[
        createScatterChartDataPoint(2, 4, ScatterChartDataPointType.On),
        createScatterChartDataPoint(12, 8, ScatterChartDataPointType.DC),
        createScatterChartDataPoint(27, 1, ScatterChartDataPointType.On),
        createScatterChartDataPoint(40, 2, ScatterChartDataPointType.On),
        createScatterChartDataPoint(50, 15, ScatterChartDataPointType.DC),
        createScatterChartDataPoint(67, 4, ScatterChartDataPointType.On),
    ]} 
    dataLength={80} />
*/